import script from "./UserTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserTable.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__